import MacroForm from './macroForm';

export default MacroForm;
